<template>
  <div>
    <v-dialog v-model="alertStake" transition="none" max-width="400">
      <v-card>
        <v-card-title class="headline">No Stake Set!</v-card-title>
        <v-card-text>
          Please set stake first
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="green darken-1" large class="white--text" @click="clearModal()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sentBet" max-width="400" transition="none">
      <v-card>
        <v-card-title v-if="betError === 'Price has changed'" class="headline red--text">Error Sending Bet!</v-card-title>
        <v-card-title v-else-if="betStatus === 'unresulted' && refundAmt == null" class="headline green--text">Bet
          Successful!</v-card-title>
        <v-card-title v-else-if="betStatus === 'paymentMade' && refundAmt == null" class="headline green--text">Bet
          Successful <br>Printing Tickets</v-card-title>
        <v-card-title v-else-if="betStatus === 'unresulted' && refundAmt != null" class="headline warning--text">Partially
          Accepted, <br>Refund Owing!</v-card-title>
        <v-card-title v-else-if="betStatus === 'rejected'" class="headline red--text">Bet Rejected!</v-card-title>
        <v-card-title v-else-if="betStatus === 'Operator Cancelled'" class="headline warning--text">Operator
          Cancelled</v-card-title>
        <v-card-title v-else-if="betStatus === 'error'" class="headline warning--text">Error Placing Bet</v-card-title>
        <v-card-title v-else-if="!hasFeature('newNavigation')" class="headline green--text">Bet Sent!</v-card-title>
        <v-card-title v-else-if="betStatus === 'sent bet slip' && refundAmt == null" class="headline green--text">Bet Slip
          Sent!</v-card-title>
        <v-card-title v-else-if="betStatus === 'sent bet slip' && refundAmt != null"
          class="headline warning--text">Partially Accepted, <br>Refund Owing!</v-card-title>
        <!-- <v-card-title v-else-if="hasFeature('newNavigation')" class="headline green--text">Added to Bet Slip!</v-card-title> -->
        <div v-if="betError != null">
          <v-card-text>
            Error Message: {{ betError }}
          </v-card-text>
          <v-card-text>
            Bet Status: {{ betStatus }}
          </v-card-text>
        </div>
        <div v-else-if="refundAmt !== null && betStatus === 'sent bet slip'">
          <v-card-text class="pa-0 pl-4" v-if="!hasFeature('newNavigation')">
            <strong>Bet Id:</strong> {{ betId }}
          </v-card-text>
          <v-card-text class="pa-0 pl-4">
            <strong>Bet Ticket ID:</strong> {{ ticketId }}
          </v-card-text>
          <v-card-text>
            <strong>Bet Slip Status:</strong> {{ betStatus }} <br>
          </v-card-text>
          <v-card-text class="pa-0 pl-4" v-for="details in betDetails" :key="details.id">
            <strong>Bet:</strong> {{ details.id }} {{ details.status }}
          </v-card-text>
          <v-card-text class="red--text" v-if="refundAmt != null">
            <strong>Refund Amount:</strong> ${{ refundAmt }}
          </v-card-text>
        </div>
        <div v-else-if="getStoredPayment !== 0 && betStatus === 'rejected'">
          <v-card-text class="pa-0 pl-4" v-if="!hasFeature('newNavigation')">
            <strong>Bet Id:</strong> {{ betId }}
          </v-card-text>
          <v-card-text class="pa-0 pl-4">
            <strong>Bet Ticket ID:</strong> {{ ticketId }}
          </v-card-text>
          <v-card-text>
            <strong>Bet Slip Status:</strong> {{ betStatus }} <br>
          </v-card-text>
          <v-card-text class="pa-0 pl-4" v-for="details in betDetails" :key="details.id">
            <strong>Bet:</strong> {{ details.id }} {{ details.status }}
          </v-card-text>
          <v-card-text class="red--text" v-if="refundAmt != null">
            <strong>Refund Amount:</strong> ${{ refundAmt }}
          </v-card-text>
          <v-card-text class="red--text" v-if="getStoredPayment != 0">
            <strong>Please refund customer:</strong> ${{ getStoredPayment }}
          </v-card-text>
        </div>
        <div v-else-if="!hasFeature('newNavigation')">
          <v-card-text>
            Bet Id: {{ betId }}
          </v-card-text>
          <v-card-text>
            Bet Status: {{ betStatus }}
          </v-card-text>
        </div>
        <div v-else-if="betStatus === 'sent bet slip'">
          <v-card-text>
            Ticket Id: {{ ticketId }}
          </v-card-text>
          <v-card-text>
            Bet Status: {{ betStatus }}
          </v-card-text>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" large v-if="getStoredPayment !== 0 && betStatus === 'rejected'" color="green darken-1"
            class="white--text" @click="clearSetStake(), addTransaction(refundAmt, 1, ticketId)">
            Process Refund
          </v-btn>
          <v-btn elevation="0" large v-else color="green darken-1" class="white--text" @click="clearSetStake()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="refundModal" max-width="400" transition="none">
      <v-card>
        <v-card-title v-if="refundError" class="headline red--text">Refund Error!</v-card-title>
        <v-card-title v-else class="headline green--text">Refund Complete</v-card-title>
        <v-card-text v-if="refundError">
          Error processing refund, contact admin
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="green darken-1" class="white--text" large @click="clearModal()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    betError: String,
    betStatus: String,
    betId: Array,
    ticketId: String,
    refundAmt: Number,
    sentBet: Boolean,
    reloadRace: Function,
    addTransaction: Function,
    clearModal: Function,
    alertStake: Boolean,
    refundModal: Boolean,
    refundError: Boolean,
    selectedRaceId: String,
    clearSetStake: Function,
    betDetails: Array

  },
  computed: {
    ...mapGetters(['hasFeature', 'getStoredPayment']),
  }

}
</script>

<style></style>